
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 4.883l6.473 11.867H3.527zm0-3.133l-9 16.5h18zM9.25 8.5h1.5V13h-1.5zm.75 7.313a.938.938 0 11.938-.938.938.938 0 01-.938.938z"}})])
          )
        }
      }
    